var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "big-logo",
      attrs: {
        width: "100",
        height: "101",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_2_182",
            maskUnits: "userSpaceOnUse",
            x: "8",
            y: "25",
            width: "84",
            height: "50"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M91.5372 69.4418C90.2542 64.19 87.9795 59.2318 84.8355 54.8339C82.8431 52.0386 80.521 49.4937 77.9193 47.2544C76.2515 45.8164 74.4754 44.5091 72.6067 43.3442L72.6529 43.2584L75.2267 38.8203L77.7444 34.4812L79.5493 31.3662C80.015 30.4736 80.1184 29.4359 79.8382 28.4689C79.5579 27.502 78.9154 26.6804 78.0446 26.1753C77.1738 25.6701 76.1416 25.5203 75.1631 25.757C74.1846 25.9938 73.3351 26.5988 72.7915 27.4461L70.9865 30.5611L68.4688 34.8969L65.895 39.3384L65.6113 39.8267L65.2219 39.6716C60.3594 37.8216 55.1995 36.8766 49.9969 36.8834H49.5581C44.3924 36.9321 39.2785 37.9182 34.4651 39.7937L34.2011 39.3417L31.6274 34.9002L29.113 30.5611L27.3047 27.4461C26.9174 26.7779 26.3406 26.2396 25.6472 25.8993C24.9539 25.559 24.1751 25.432 23.4096 25.5345C22.6441 25.6369 21.9261 25.9642 21.3466 26.4748C20.7671 26.9854 20.3522 27.6565 20.1542 28.4031C19.8889 29.4043 20.0313 30.4698 20.5502 31.3662L22.3551 34.4845L24.8728 38.8203L27.4466 43.2617L27.4697 43.298C20.9407 47.3524 15.6192 53.0842 12.06 59.8957C10.4822 62.9229 9.2746 66.1292 8.46326 69.4451C7.74392 72.3687 10.1098 74.9952 13.1225 74.9952H86.8681C89.8775 74.9952 92.2566 72.3654 91.5372 69.4418Z",
              fill: "#34A853"
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_2_182)" } }, [
        _c("path", {
          attrs: {
            d: "M92.9892 23.9384H2.23016V75.005H92.9892V23.9351V23.9384Z",
            fill: "#4FAF53"
          }
        }),
        _c("g", { attrs: { filter: "url(#filter0_f_2_182)" } }, [
          _c("path", {
            attrs: {
              d:
                "M48.2745 43.1693C56.8802 49.9997 32.6305 50.7586 23.256 65.6569C13.8848 80.5519 21.3817 106.451 12.776 99.6243C7.46018 91.4509 6.62864 74.8302 16.0032 59.9286C25.3744 45.0336 40.9293 40.1368 48.2415 43.1693H48.2745Z",
              fill: "url(#paint0_linear_2_182)",
              "fill-opacity": "0.4"
            }
          })
        ]),
        _c("g", { attrs: { filter: "url(#filter1_f_2_182)" } }, [
          _c("path", {
            attrs: {
              d:
                "M51.9966 43.1231C42.9554 49.5774 68.4392 50.2934 78.2889 64.3734C88.1386 78.45 80.2588 102.924 89.3034 96.4731C94.8898 88.7485 95.7609 73.0418 85.9113 58.9618C76.0616 44.8819 59.718 40.2556 52.0296 43.1231H51.9966Z",
              fill: "url(#paint1_linear_2_182)",
              "fill-opacity": "0.4"
            }
          })
        ]),
        _c(
          "g",
          { attrs: { opacity: "0.6", filter: "url(#filter2_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M2.90987 64.0005C-0.544944 74.8731 -2.3235 84.0101 -1.063 84.4093C0.197496 84.8086 4.01858 76.325 7.4767 65.4524C10.9315 54.5831 25.183 42.7305 23.9225 42.3312C22.6621 41.9286 6.36799 53.1312 2.90987 64.0005Z",
                fill: "#8BD8A0"
              }
            })
          ]
        ),
        _c(
          "g",
          { attrs: { opacity: "0.5", filter: "url(#filter3_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M93.164 63.0105C96.6188 73.8798 98.3974 83.0168 97.1369 83.4161C95.8764 83.8186 92.0553 75.3317 88.6005 64.4591C85.1457 53.5898 70.8909 41.7372 72.1514 41.3379C73.4119 40.9386 89.7059 52.1412 93.164 63.0105Z",
                fill: "#8BD8A0"
              }
            })
          ]
        ),
        _c(
          "g",
          { attrs: { opacity: "0.7", filter: "url(#filter4_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M23.6652 34.0257C27.0837 39.6452 28.5818 42.3245 28.0868 42.6281C27.5919 42.9284 25.2853 40.7407 21.8635 35.1212C16.6961 30.5775 22.1605 24.4268 22.6588 24.1232C23.1537 23.8197 18.577 26.5782 23.6652 34.0257Z",
                fill: "#0D652D"
              }
            })
          ]
        ),
        _c(
          "g",
          { attrs: { opacity: "0.1", filter: "url(#filter5_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M27.4268 43.2121C27.836 42.9481 25.678 38.9158 22.5993 34.2137C19.5273 29.5116 16.7027 25.9149 16.2936 26.1822C15.8844 26.4462 18.0424 30.4784 21.1211 35.1806C24.1931 39.886 27.0177 43.4827 27.4268 43.2121Z",
                fill: "#202124"
              }
            })
          ]
        ),
        _c(
          "g",
          { attrs: { opacity: "0.3", filter: "url(#filter6_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M27.9218 31.1582C31.502 37.035 33.2476 39.7309 33.6435 39.4867C34.0395 39.2458 32.9407 36.1606 29.3605 30.2805C25.909 22.4271 19.6857 27.1127 20.2994 27.9706C21.4939 30.2706 23.3451 22.9155 27.9218 31.1582Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("path", {
          attrs: {
            opacity: "0.15",
            d:
              "M16.8578 29.0497C17.4847 31.2209 19.976 32.4055 22.4211 31.6961C24.8662 30.9899 26.3412 28.6603 25.7109 26.4891C25.084 24.3179 22.5927 23.1333 20.1476 23.8427C17.7058 24.5489 16.2308 26.8785 16.8578 29.0497Z",
            fill: "url(#paint2_radial_2_182)",
            "fill-opacity": "0.9"
          }
        }),
        _c("path", {
          attrs: {
            opacity: "0.15",
            d:
              "M73.897 28.4821C74.5437 30.7128 77.1967 31.9073 79.82 31.145C82.4465 30.3861 84.0502 27.9608 83.4068 25.7302C82.76 23.4996 80.107 22.3051 77.4838 23.0673C74.8572 23.8262 73.2535 26.2515 73.897 28.4821Z",
            fill: "url(#paint3_radial_2_182)",
            "fill-opacity": "0.9"
          }
        }),
        _c(
          "g",
          { attrs: { opacity: "0.1", filter: "url(#filter7_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M72.3526 43.5189C71.9369 43.2583 74.0355 39.1963 77.0316 34.4447C80.0311 29.6931 82.7963 26.0502 83.2087 26.3109C83.6212 26.5715 81.5259 30.6335 78.5264 35.3851C75.5303 40.1367 72.7684 43.7796 72.3526 43.5189Z",
                fill: "#202124"
              }
            })
          ]
        ),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: "mask1_2_182",
              maskUnits: "userSpaceOnUse",
              x: "64",
              y: "34",
              width: "15",
              height: "10"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M73.0126 43.5915C70.9998 42.3377 66.4 40.1796 64.3508 39.259L65.7037 34.4711L78.929 39.7903C77.7939 41.582 75.0255 44.8487 73.0126 43.5915Z",
                fill: "black"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#mask1_2_182)" } }, [
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "multiply" },
              attrs: { opacity: "0.3", filter: "url(#filter8_f_2_182)" }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M74.3589 42.8919C70.7589 41.3708 67.6836 40.4996 67.4955 40.9484C67.3041 41.4005 70.0363 42.6643 73.6363 44.1887C77.2396 45.7099 80.3479 46.9143 80.5393 46.4655C80.7274 46.0135 77.9622 44.4164 74.3589 42.8919Z",
                  fill: "#0D652D"
                }
              })
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "screen" },
              attrs: { opacity: "0.3", filter: "url(#filter9_f_2_182)" }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M66.9775 40.018C65.9744 39.5263 65.0801 39.2854 64.9844 39.4801C64.8887 39.6781 65.6444 40.0972 66.6442 40.5921C67.6473 41.0871 68.525 41.4633 68.6207 41.2686C68.7164 41.0706 67.9806 40.5096 66.9775 40.018Z",
                  fill: "#81C995"
                }
              })
            ]
          )
        ]),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "alpha" },
            attrs: {
              id: "mask2_2_182",
              maskUnits: "userSpaceOnUse",
              x: "20",
              y: "34",
              width: "16",
              height: "11"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M26.5524 43.9908C28.5356 42.694 33.0892 40.4469 35.1218 39.4801L33.6699 34.7219L20.5601 40.3116C21.7282 42.0803 24.566 45.2876 26.5524 43.9908Z",
                fill: "black"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#mask2_2_182)" } }, [
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "multiply" },
              attrs: { opacity: "0.3", filter: "url(#filter10_f_2_182)" }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M25.1897 43.2912C28.76 41.6941 31.8155 40.7603 32.0168 41.2058C32.2148 41.6512 29.509 42.9744 25.9387 44.5715C22.3684 46.1686 19.2865 47.4356 19.0885 46.9902C18.8905 46.5447 21.6161 44.8883 25.1897 43.2912Z",
                  fill: "#0D652D"
                }
              })
            ]
          ),
          _c(
            "g",
            {
              staticStyle: { "mix-blend-mode": "screen" },
              attrs: { opacity: "0.3", filter: "url(#filter11_f_2_182)" }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M32.492 40.2753C33.4819 39.7605 34.3729 39.5032 34.4719 39.6978C34.5709 39.8925 33.8284 40.3248 32.8352 40.8396C31.842 41.3543 30.9742 41.7503 30.8752 41.5556C30.7762 41.3642 31.4988 40.7901 32.492 40.2753Z",
                  fill: "#81C995"
                }
              })
            ]
          )
        ]),
        _c(
          "g",
          { attrs: { opacity: "0.7", filter: "url(#filter12_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M76.5598 34.26C73.2699 39.9553 71.8346 42.671 72.3361 42.9613C72.8443 43.2517 75.0947 41.0112 78.3845 35.3126C83.4463 30.65 77.8368 24.6247 77.3319 24.3344C76.8303 24.044 81.4698 26.697 76.5598 34.26Z",
                fill: "#0D652D"
              }
            })
          ]
        ),
        _c(
          "g",
          { attrs: { opacity: "0.3", filter: "url(#filter13_f_2_182)" } },
          [
            _c("path", {
              attrs: {
                d:
                  "M72.0325 31.475C68.6833 37.2792 67.0401 39.9322 66.6144 39.688C66.192 39.4438 67.149 36.3883 70.4982 30.5907C74.3127 20.5166 81.8756 21.8464 80.6349 27.3569C79.6582 29.6172 76.2694 23.3412 72.0325 31.475Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("path", {
          attrs: {
            d:
              "M33.6666 57.3976C34.2144 56.7773 33.7524 55.4607 32.6338 54.4543C31.5119 53.4478 30.1623 53.1344 29.6146 53.758C29.0668 54.3784 29.5288 55.695 30.6474 56.7014C31.7693 57.7078 33.1189 58.0213 33.6666 57.3976Z",
            fill: "url(#paint4_radial_2_182)",
            "fill-opacity": "0.7"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M70.9206 56.7641C72.0425 55.7577 72.5044 54.4411 71.9534 53.8208C71.4056 53.1971 70.056 53.5106 68.9374 54.5137C67.8155 55.5234 67.3535 56.84 67.9046 57.4604C68.4524 58.084 69.8019 57.7673 70.9206 56.7641Z",
            fill: "url(#paint5_radial_2_182)",
            "fill-opacity": "0.7"
          }
        }),
        _c("path", {
          attrs: {
            opacity: "0.09",
            d:
              "M33.2146 61.529C34.574 58.1402 33.1486 56.0514 32.2675 55.4047C29.7234 52.2567 26.295 54.6854 25.282 56.0547C24.2624 57.3878 22.7709 59.7834 24.2294 63.07C25.6879 66.3532 31.5218 65.7724 33.2146 61.529ZM68.3798 61.6049C67.0236 58.2524 68.4458 56.1273 69.3301 55.5136C71.8709 52.3656 75.296 54.7942 76.3156 56.1636C77.3319 57.4967 78.8234 59.8923 77.3649 63.1459C75.9064 66.3961 70.0725 65.8483 68.3798 61.6379V61.6049Z",
            fill: "#011B04"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M76.0483 63.9212C78.1502 62.5188 78.4901 59.2686 76.7941 56.7014C75.098 54.1342 72.0095 53.2103 69.9108 54.6127C67.8089 56.0183 67.469 59.2653 69.1651 61.8325C70.8578 64.3996 73.9464 65.3236 76.0483 63.9212Z",
            fill: "#202124"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M32.4029 61.7301C34.0989 59.163 33.7954 55.9787 31.7264 54.5763C29.6575 53.2102 26.6382 54.1672 24.9422 56.6981C23.2461 59.2652 23.553 62.4462 25.6219 63.8519C27.6909 65.218 30.7068 64.261 32.4029 61.7301ZM69.1684 61.7664C67.4724 59.2025 67.776 56.0183 69.8449 54.6159C71.9138 53.2465 74.9331 54.2068 76.6291 56.7377C78.3252 59.3048 78.0183 62.4858 75.9494 63.8882C73.8805 65.2575 70.8645 64.3006 69.1684 61.7664Z",
            fill: "black"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M25.5526 56.3945C23.9259 58.381 23.7543 60.7403 23.9589 61.7335C23.553 59.7834 23.6883 57.8992 25.2458 55.9854C26.0938 54.9229 27.417 54.3421 28.3673 54.0682C28.5026 54.0352 28.6742 54.0022 28.7732 53.9659C28.9604 53.907 29.1545 53.8726 29.3506 53.8636C29.1823 53.8966 28.9778 53.9329 28.7732 53.9659C28.6412 53.9659 28.5026 54.0352 28.3673 54.0682C27.6876 54.3091 26.7735 54.8206 25.5196 56.3945H25.5526Z",
            fill: "black"
          }
        }),
        _c("path", {
          attrs: {
            opacity: "0.8",
            d:
              "M32.8483 56.8795C32.1718 54.0385 29.8983 53.7646 28.849 53.9692C29.763 53.5567 31.3898 54.0682 32.1025 54.8931C32.647 55.5431 32.8483 56.5001 32.8846 56.9125L32.8516 56.8795H32.8483Z",
            fill: "url(#paint6_linear_2_182)"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M71.8115 54.474C69.4027 54.6093 68.624 56.5264 68.5217 57.4504C68.7592 56.8696 69.6436 55.6685 71.1681 55.3649C72.6925 55.0911 74.6955 56.8333 75.5072 57.7572L76.2529 56.9026C75.7778 56.0117 74.2203 54.3024 71.8115 54.474Z",
            fill: "url(#paint7_linear_2_182)"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M76.0121 56.4606C77.6422 58.4437 77.8104 60.8063 77.6059 61.7963C78.015 59.8494 77.8764 57.9653 76.319 56.0481C75.4709 54.9889 74.1478 54.4049 73.1974 54.1343C73.0654 54.1013 72.8939 54.065 72.7916 54.0287C72.6042 53.9709 72.4101 53.9376 72.2141 53.9297C72.3857 53.9627 72.587 53.9957 72.7916 54.0287C72.9269 54.0287 73.0621 54.098 73.1974 54.131C73.8772 54.3719 74.7912 54.8866 76.0484 56.4606H76.0121Z",
            fill: "black"
          }
        }),
        _c("path", {
          attrs: {
            opacity: "0.8",
            d:
              "M27.6842 55.6553C26.7338 55.8599 26.0211 56.8531 25.8198 57.3316L26.295 58.0509C26.295 58.0509 26.6316 57.4669 27.0044 57.094C27.3773 56.7145 27.9547 56.3021 28.1923 56.1338L27.7172 55.6553H27.6842ZM73.9134 55.6784C74.8307 55.85 75.5401 56.8102 75.7777 57.2887L75.3059 57.9717C75.3059 57.9717 74.966 57.424 74.5931 57.0478C74.2202 56.6716 73.6758 56.2955 73.4382 56.1239L73.9134 55.6784Z",
            fill: "#E2DCE1"
          }
        }),
        _c("g", { attrs: { opacity: "0.8" } }, [
          _c("path", {
            attrs: {
              d:
                "M31.5515 60.7832C31.1093 61.0241 30.3966 61.3673 30.093 61.5025L29.8224 62.3242C30.5319 62.0833 31.0433 61.6741 31.2446 61.5025L31.5515 60.7832ZM32.9737 57.1865C32.9007 56.9406 32.8103 56.7002 32.7031 56.4672V56.774C32.8351 57.0149 32.9407 57.4571 32.9737 57.665C32.9737 57.5957 33.0397 57.3911 32.9737 57.1502V57.1865Z",
              fill: "#E2DCE1"
            }
          })
        ]),
        _c("g", { attrs: { opacity: "0.8" } }, [
          _c("path", {
            attrs: {
              d:
                "M69.9472 60.8558C70.386 61.0934 71.1021 61.4365 71.4056 61.5751L71.6762 62.3935C71.1543 62.2117 70.6708 61.9342 70.2507 61.5751L69.9472 60.8558ZM68.5514 57.2558C68.6174 57.0149 68.756 56.675 68.8219 56.5364V56.8466C68.6903 57.1294 68.5992 57.4293 68.5514 57.7375C68.5514 57.6649 68.4854 57.4604 68.5514 57.2228V57.2558Z",
              fill: "#E2DCE1"
            }
          })
        ])
      ]),
      _c(
        "defs",
        [
          _c(
            "filter",
            {
              attrs: {
                id: "filter0_f_2_182",
                x: "7.84369",
                y: "41.3134",
                width: "43.2477",
                height: "60.4348",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "0.5",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter1_f_2_182",
                x: "49.0883",
                y: "41.3134",
                width: "45.3466",
                height: "57.2216",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "0.5",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter2_f_2_182",
                x: "-20.2842",
                y: "23.5046",
                width: "63.1014",
                height: "79.7342",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "9.408",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter3_f_2_182",
                x: "53.2567",
                y: "22.5115",
                width: "63.1014",
                height: "79.7343",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "9.408",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter4_f_2_182",
                x: "-5.43041",
                y: "-0.987139",
                width: "58.6975",
                height: "68.7302",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "12.544",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter5_f_2_182",
                x: "9.97177",
                y: "19.8962",
                width: "23.7768",
                height: "29.6022",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.136",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter6_f_2_182",
                x: "1.4412",
                y: "6.98646",
                width: "51.0948",
                height: "51.3314",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "9.408",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter7_f_2_182",
                x: "66.0281",
                y: "20.0257",
                width: "23.5044",
                height: "29.7784",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.136",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter8_f_2_182",
                x: "54.942",
                y: "28.2864",
                width: "38.1504",
                height: "30.8181",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.272",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter9_f_2_182",
                x: "57.4503",
                y: "31.8866",
                width: "18.7048",
                height: "16.9602",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.763",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter10_f_2_182",
                x: "6.53437",
                y: "28.5506",
                width: "38.0367",
                height: "31.0738",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "6.272",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter11_f_2_182",
                x: "23.3401",
                y: "32.1069",
                width: "18.6666",
                height: "17.0252",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "3.763",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter12_f_2_182",
                x: "47.1505",
                y: "-0.774889",
                width: "58.4231",
                height: "68.849",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "12.544",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "filter",
            {
              attrs: {
                id: "filter13_f_2_182",
                x: "47.7048",
                y: "4.29154",
                width: "51.8821",
                height: "54.2279",
                filterUnits: "userSpaceOnUse",
                "color-interpolation-filters": "sRGB"
              }
            },
            [
              _c("feFlood", {
                attrs: { "flood-opacity": "0", result: "BackgroundImageFix" }
              }),
              _c("feBlend", {
                attrs: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              }),
              _c("feGaussianBlur", {
                attrs: {
                  stdDeviation: "9.408",
                  result: "effect1_foregroundBlur_2_182"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_2_182",
                x1: "15.5412",
                y1: "59.5524",
                x2: "28.4729",
                y2: "67.6631",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#A8F0B9" } }),
              _c("stop", {
                attrs: {
                  offset: "0.807",
                  "stop-color": "#ADEEBC",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear_2_182",
                x1: "86.3963",
                y1: "58.6021",
                x2: "73.6594",
                y2: "67.4916",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                attrs: { offset: "0.292", "stop-color": "#A8F0B9" }
              }),
              _c("stop", {
                attrs: {
                  offset: "0.828",
                  "stop-color": "#ADEEBC",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "radialGradient",
            {
              attrs: {
                id: "paint2_radial_2_182",
                cx: "0",
                cy: "0",
                r: "1",
                gradientTransform:
                  "matrix(-2.77481 0.831598 -0.629258 -2.09962 21.286 27.7694)",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "white" } }),
              _c("stop", {
                attrs: {
                  offset: "0.948",
                  "stop-color": "white",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "radialGradient",
            {
              attrs: {
                id: "paint3_radial_2_182",
                cx: "0",
                cy: "0",
                r: "1",
                gradientTransform:
                  "matrix(-2.98032 0.891851 -0.646285 -2.15967 78.6519 27.1062)",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "white" } }),
              _c("stop", {
                attrs: {
                  offset: "0.948",
                  "stop-color": "white",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "radialGradient",
            {
              attrs: {
                id: "paint4_radial_2_182",
                cx: "0",
                cy: "0",
                r: "1",
                gradientUnits: "userSpaceOnUse",
                gradientTransform:
                  "translate(33.9388 55.9677) rotate(132.973) scale(1.16741 2.12503)"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#93E19F" } }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#93E19F",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "radialGradient",
            {
              attrs: {
                id: "paint5_radial_2_182",
                cx: "0",
                cy: "0",
                r: "1",
                gradientUnits: "userSpaceOnUse",
                gradientTransform:
                  "translate(70.4567 55.5172) rotate(47.027) scale(1.16639 2.124)"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#93E19F" } }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#93E19F",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint6_linear_2_182",
                x1: "30.7463",
                y1: "52.7714",
                x2: "30.9179",
                y2: "56.7739",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#E2DDE2" } }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#E2DDE2",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint7_linear_2_182",
                x1: "72.389",
                y1: "54.474",
                x2: "72.389",
                y2: "57.7572",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#373637" } }),
              _c("stop", {
                attrs: {
                  offset: "1",
                  "stop-color": "#373637",
                  "stop-opacity": "0"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }